import { format, subDays } from 'date-fns';
import type { CoreRequest, PaymentRequest } from '$api-clients/hooks';

export const LISTING_AGREEMENTS_NEEDS_ATTENTION_FILTERS =
  'status:active,status:activeCont,status:backUp,status:comingSoon,status:offMarket,status:onMarket,status:pending,status:preListing,isArchived:false';

export function buildCommissionFormUrl(
  data?: PaymentRequest<'/transactions/{transactionId}'>['Data'],
  interactionType?: CoreRequest<'/interactions/{interactionId}'>['Data']['type'],
) {
  if (!data) {
    return undefined;
  }

  const { interactionId, id, externalId } = data;
  const transactionId = id ?? externalId;

  if (interactionType && interactionId) {
    return `/payment/${interactionType}s/${interactionId}/commission-forms/${transactionId}/?utm_source=hp&utm_medium=nac`;
  }

  return `/payment/commission-forms/${transactionId}/?utm_source=hp&utm_medium=nac`;
}

export const getEnvelopeRequestQueryParams = () => {
  const interactionStatusFacet =
    'status:active,status:activeCont,status:backUp,status:comingSoon,status:offMarket,status:onMarket,status:pending,status:preListing,status:ratified,isArchived:false';

  const envelopeStatusFacet =
    'envelopes.status:sent,envelopes.status:delivered';

  const currentDate = new Date();
  const dateNinetyDaysAgo = format(subDays(currentDate, 90), 'yyyy-MM-dd');
  const date1DayAgo = format(subDays(currentDate, 1), 'yyyy-MM-dd');
  const envelopeSentAtFacet = `envelopes.sentAt:[${dateNinetyDaysAgo} TO ${date1DayAgo}]`;
  const envelopeReminderSentAtFacet = `envelopes.reminderSentAt:[${dateNinetyDaysAgo} TO ${date1DayAgo}]`;

  return {
    interactionStatusFacet,
    envelopeStatusFacet,
    envelopeSentAtFacet,
    envelopeReminderSentAtFacet,
  };
};
